<template>
    <!--Instruction section start  -->

    <div class="container instruction-section my-lg-5 pt-lg-5">
      <div class="row ">
        <!-- LEFT COLUMN: Charges & Instructions (col-7) -->
        <div class="col-xl-7 pe-xl-5 mb-4 mb-xl-0 left-instruction-column" style="border-right: 1px solid #ccc;">
          <div class="mb-4">
            <h4 class="py-2 text-center Instruction_heading">Charges & Instructions For Visa Medical</h4>

            

            <div v-if="entities.length === 0">Loading...</div>

            <div v-else v-for="(country, index) in sanitizedEntities" :key="index" class="mb-4">
              <h4 class="mt-4 d-flex align-items-center">
                <img :src="country.image" width="75" class="me-2"> {{ country.title }}
              </h4>

              <div v-html="country.charges_instruction" class="word-break instruction-scroll"></div>
              <hr>
            </div>


          </div>
        </div>
        
      
        <!-- RIGHT COLUMN: Info Boxes (col-5) -->
        <div class="col-xl-5 ps-xl-4 info-column">
          <h4 class="py-2 text-center Instruction_heading">General Information :</h4>
          <p>The tests included in the medical examination are as prescribed by the Immigration authorities of Australia/New Zealand/Canada/UK. If required, additional tests are to be done as per their protocol.</p>
            <h4 class="py-2 text-center Instruction_heading mt-3">The tests depend on:</h4>
            <ul>
              <li>Type of visa</li>
              <li>Length of stay</li>
              <li>Age of applicant</li>
              <li>Any medical issues in medical examination</li>
            </ul>
            <p>We are now online; you can book your visa medical appointments through our platform : <span class="text-red">visamedical.kimshealth.org</span></p>
            <h6><b>Your online appointment confirmation is contingent upon the payment of a non-refundable amount of ₹100.</b></h6> 
            <!-- which will be deducted from your visa medical charges. -->
            <p><strong>For enquiries and cancelations contact : </strong><span class="text-red">0471 294 1938 | 1950 | 1312</span> between 8.00 am and 5.30 pm, Monday to Saturday.</p>
            <p><strong>Email us at </strong><a href="mailto:medicals.tvm@kimsglobal.com" class="text-red">medicals.tvm@kimsglobal.com</a></p>
            <p>Informed consent is signed by every applicant as authorized by the Immigration Departments of Australia | New Zealand | Canada | UK.</p>
            <p>Parent or guardian should sign on behalf of  <span class="text-red">minor children*</span> and persons with intellectual disability.</p>
            <span class="text-red">*Under 16 years for Australia, Canada and UK</span>
            <br>
            <br>
            <span class="text-red">*Under 18 years for New Zealand</span>
            <br>
            <br>
            <p>Medical examination reports for Australia | New Zealand | Canada will be submitted on e-Medical portal within 2 to 5 working days</p>
              <h4 class="py-2 text-center Instruction_heading">Other Information :</h4>
              <ul>
                <li>Fasting is not required</li>
                <li>If you use spectacles, please bring them</li>
                <li>If you have any medical history, please bring medical reports</li>
                <li>Females in their menstrual cycle are advised to postpone their appointments</li>
                <li>Kindly avoid carrying valuable items with you while visiting hospital for medical examination</li>
              </ul>
        </div>

    </div>
    </div>
 
<!--Instruction section end  -->
</template>

<script>
  import { GetEntities } from '@/api/Front/home';
  import { useEntityStore } from '@/store/entities';
  export default {
    name: 'HomeInstructions',
    computed: {
      sanitizedEntities() {
        return this.entities.map(country => {
          if (!country.charges_instruction) return country;

          const temp = document.createElement('div');
          temp.innerHTML = country.charges_instruction;

          // Remove empty paragraphs
          temp.querySelectorAll('p').forEach(p => {
            if (!p.textContent.trim()) p.remove();
          });

          // Remove extra <br> at the start or end
          temp.innerHTML = temp.innerHTML.replace(/^(<br\s*\/?>)+|(<br\s*\/?>)+$/gi, '');

          // Replace multiple &nbsp; with a single space
          temp.innerHTML = temp.innerHTML.replace(/&nbsp;/g, ' ');

          temp.querySelectorAll('[style]').forEach(el => {
            const style = el.getAttribute('style').toLowerCase();
            // Remove white backgrounds that hide text
            if (style.includes('background-color: rgb(255, 255, 255)') || style.includes('background-color: #ffffff')) {
              el.style.backgroundColor = 'transparent';
            }
            // If text color is white or too light, make it black
            if (style.includes('color: #fff') || style.includes('color: rgb(255, 255, 255)')) {
              el.style.color = '#000';
            }
          });

          return {
            ...country,
            charges_instruction: temp.innerHTML
          };
        });
      }
    },

    data() {
      return {
        entities: [],
      };
    },
    mounted() {
      this.loadEntities();
    },
    methods: {
      async loadEntities() {
        try {
          const response = await GetEntities();
          this.entities = response.data.data;
        } catch (error) {
          console.error('Failed to fetch entities:', error);
        }
      },
    },
  };
</script>
<style>
.word-break {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.instruction-section img {
  vertical-align: middle;
}

.instruction-scroll {
  /* allow scrolling on all devices (don't rely on :hover) */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* smooth momentum scrolling on iOS */
  max-height: 50vh;                 /* responsive max height - use viewport height */
  padding-right: 8px;               /* space to avoid content clipping with scrollbar */
  transition: all 0.12s ease;
  scrollbar-width: thin;            /* firefox */
  scrollbar-color: rgba(0,0,0,0.25) transparent;
  overscroll-behavior: contain;     /* avoid parent page scroll jump when reaching edges */
  touch-action: pan-y;              /* hint for better touch/scroll handling */
  -ms-overflow-style: none;         /* hide IE scrollbar if wanted */
}

.instruction-scroll:hover {
  overflow-y: auto; /* enable scrolling on hover */
}

/* Webkit browsers */
.instruction-scroll::-webkit-scrollbar {
  width: 6px;
}

.instruction-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.instruction-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
}

/* Firefox */
.instruction-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,0.3) transparent;
}

@media (max-width: 991px) {
  /* On mobile/tablet: full width, no border */
  .left-instruction-column,
  .info-column {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
    border: none;
    padding: 15px;
  }

  /* Add a visual separator for clarity */
  .left-instruction-column {
    border-bottom: 1px solid #ddd;
    margin-bottom: 25px;
  }
}

/* Border divider only on desktop (≥1200px) */
@media (min-width: 1200px) {
  .left-instruction-column {
    border-right: 1px solid #ccc;
  }
}

/* On mobile/tablet (≤1199px): full width, stack vertically */
@media (max-width: 1199px) {
  .left-instruction-column,
  .info-column {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
    border: none;
    padding: 15px;
  }

  .left-instruction-column {
    border-bottom: 1px solid #ddd;
    margin-bottom: 25px;
  }
}

</style>
  
  